import { useEffect, useState } from 'react';

const useDebouncedEffect = (initialValue = '', delay: number): [string, Function] => {
	const [actualValue, setActualValue] = useState(initialValue);
	const [debouncedValue, setDebouncedValue] = useState(initialValue);

	useEffect(() => {
		const debouncedIdentifier = setTimeout(() => setDebouncedValue(actualValue), delay);
		return (): void => clearTimeout(debouncedIdentifier);
	}, [actualValue, delay]);

	return [debouncedValue, setActualValue];
};

export default useDebouncedEffect;
